import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { educationLevels, experienceLevels, countries, salaries } from './more-info-options';

export function formatMonthYear(value) {
  return value ? format(parseISO(value), 'MMM yyyy') : '';
}

export function formatYear(value) {
  return value ? format(parseISO(value), 'yyyy') : '';
}

export function formatSalary(value) {
  const salary = salaries.find((element) => element.value === value);
  return salary ? salary.text : `$${value}`;
}

export function formatExperience(value) {
  const experienceLevel = experienceLevels.find((element) => element.value === value);
  return experienceLevel ? experienceLevel.text : value;
}

export function formatEducation(value) {
  const educationLevel = educationLevels.find((element) => element.value === value);
  return educationLevel ? educationLevel.text : value;
}

export function formatCountry(value) {
  const country = countries.find((element) => element.value === value);
  return country ? country.text : value;
}

export function formatLessText(text, cutoff) {
  return `${text.substring(0, cutoff)}...`;
}
